import { facetOptionSlug } from 'client-portal/utils/clinicianSearch/facet-option-slug';

const LABEL_KEY_PREFIX = 'booking.clinicianSearch.facets.ageGroups';

export const CLINICIAN_SEARCH_AGE_GROUPS = [
  { key: 'Toddlers (under 6)', labelKey: 'toddlers' },
  { key: 'Children (6-12)', labelKey: 'children' },
  { key: 'Teenagers (12-18)', labelKey: 'teenagers' },
  { key: 'Young Adults (18-24)', labelKey: 'youngAdults' },
  { key: 'Adults (24+)', labelKey: 'adults' },
  { key: 'Elders (65+)', labelKey: 'elders' },
];

export function ageGroupLabelKeyFor(value) {
  let needle = String(value ?? '')
    .trim()
    .toLowerCase();
  let match = CLINICIAN_SEARCH_AGE_GROUPS.find(option => option.key.toLowerCase() === needle);
  return match ? `${LABEL_KEY_PREFIX}.${match.labelKey}` : null;
}

export function buildAgeGroupFacetOptions(buckets = []) {
  let countByLower = new Map();
  for (let bucket of buckets) {
    let key = String(bucket?.key ?? '')
      .trim()
      .toLowerCase();
    if (key) {
      countByLower.set(key, (countByLower.get(key) ?? 0) + Number(bucket?.count ?? 0));
    }
  }

  return CLINICIAN_SEARCH_AGE_GROUPS.map(({ key, labelKey }) => ({
    key,
    slug: facetOptionSlug(key),
    labelKey: `${LABEL_KEY_PREFIX}.${labelKey}`,
    docCount: countByLower.get(key.toLowerCase()) ?? 0,
  }));
}
